import { createContext, useContext } from 'react'

export const AmplitudeContext = createContext<{
  incrementSwapCount: () => void
  incrementDepositCount: () => void
  incrementWithdrawCount: () => void
}>(null as any)

export function useAmplitude() {
  return useContext(AmplitudeContext)
}
